module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Folder-check-9ab5957c78330f3bd2adced204ffc35a.svg";